import { useState, useRef, useEffect } from "react";
import { reportContent } from "../utils/report";
import "./ThreeDotsMenu.css";

export default function ThreeDotsMenu({ type, id, ownerId, currentUid, onBlock }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", close);
    document.addEventListener("touchstart", close);
    return () => {
      document.removeEventListener("mousedown", close);
      document.removeEventListener("touchstart", close);
    };
  }, []);

  // Hide on own content or when logged out
  if (!currentUid || currentUid === ownerId) return null;

  return (
    <div className="tdm" ref={ref} onClick={(e) => e.stopPropagation()}>
      <button
        type="button"
        className="tdm-btn"
        aria-label="More options"
        onClick={() => setOpen((o) => !o)}
      >
        ⋮
      </button>

      {open && (
        <div className="tdm-dropdown">
          <button
            type="button"
            onClick={() => {
              reportContent({ type, id, ownerId });
              setOpen(false);
            }}
          >
            Report
          </button>
          <button
            type="button"
            className="tdm-danger"
            onClick={() => {
              setOpen(false);
              onBlock(ownerId);
            }}
          >
            Block user
          </button>
        </div>
      )}
    </div>
  );
}